export default __webpack_public_path__ + "static/media/equip.dd7ab845.svg";